/**
 * Used for displaying ObjectStatus with the right color for process instance statuses.
 * Colors are:
 * color grey, ObjectStatus.state: None
 * color orange, ObjectStatus.state: Warning
 * color green, ObjectStatus.state: Success
 * color red, ObjectStatus.state: Error
 * color blue, ObjectStatus.state: Information
 * color purple, ObjectStatus.state: Indication06
 * @returns state parameter for ObjectStatus
 */
export function GetStateForWorkOrderStatus(status: string): string {
  switch (status) {
    case "draft":
      return "Indication19";
    case "new":
      return "Warning";
    case "notAccepted":
      return "Indication03";
    case "inProgress":
      return "Information";
    case "finished":
      return "Indication14";
    case "rejected":
      return "Information";
    case "closed":
      return "Success";
    case "billed":
      return "Indication09";
    case "cancelled":
      return "Error";
    default:
      return "None";
  }
}

export function GetButtonTypeForWorkOrderStatus(status: string): string {
  switch (status) {
    case "inProgress":
    case "new":
      return "Emphasized";
    case "finished":
      return "Success";
    case "rejected":
      return "Emphasized";
    case "notAccepted":
      return "Reject";
    case "cancelled":
      return "Negative";
    case "closed":
    case "billed":
      return "Success";
    case "draft":
    default:
      return "Neutral";
  }
}

export function GetTextKeyForWorkOrderStatusButton(status: string): string {
  switch (status) {
    case "inProgress":
      return "toInProgress";
    case "new":
      return "toNew";
    case "notAccepted":
      return "toNotAccepted";
    case "finished":
      return "toFinished";
    case "rejected":
      return "toRejected";
    case "closed":
      return "toClosed";
    case "cancelled":
      return "toCancelled";
    case "draft":
      return "toDraft";
    default:
      console.error("Unknown work order status: " + status);
      return status;
  }
}
